import React from 'react';
import { useNavigate } from 'react-router-dom';
import emailicon from "../email/emailicon.png"

export default function Checkyouremail() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      <div className="w-full border-b border-[#0B214E33] p-6 flex flex-row justify-between">
        <img src="/fx_logo_old.png" alt="Email Icon" className="w-[160px]" />
      </div>

      <div className="flex flex-col items-center justify-center flex-grow px-6 text-center">
        <img src={emailicon} alt="Email Icon" className="w-40 h-40 mb-6" />

        <h1 className="text-2xl font-bold text-[#0B214E] mb-3">
          Check Your Email
        </h1>

        <p className="text-base text-[#0B214ECC] font-semibold mb-2">
          We’ve sent you an email with instructions on how to reset the 6 digit
          PIN.
        </p>
        <p className="text-base text-[#0B214ECC] font-semibold  mb-8">
          If the email has not arrived yet, check your spam folder.
        </p>

        <button
          onClick={() => navigate('/business/')}
          className="bg-[#0B215E] text-white font-medium px-10 py-2 rounded-md shadow-sm hover:bg-[#122f75] transition-all"
        >
          Back to login
        </button>
      </div>
    </div>
  );
}
